export default __webpack_public_path__ + "static/media/bg.d4b20989.png";